/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Light_Tasty_Jannes_HushInputs */

const fr_light_tasty_jannes_hush = /** @type {(inputs: Light_Tasty_Jannes_HushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigateur courant`)
};

/**

* @param {Light_Tasty_Jannes_HushInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const light_tasty_jannes_hush = /** @type {((inputs?: Light_Tasty_Jannes_HushInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Light_Tasty_Jannes_HushInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_light_tasty_jannes_hush(inputs)
});